var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "5.555in",
    height: "5.521in",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 555 552",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M321 275l0 -52c-1,-6 0,-12 2,-18 2,-6 5,-11 10,-15 4,-4 10,-7 15,-9 6,-2 12,-3 18,-2l35 0 0 -69c-21,-3 -41,-5 -62,-6 -14,-1 -29,1 -42,6 -13,5 -25,13 -35,24 -10,10 -17,23 -22,36 -5,14 -6,28 -5,42l0 61 -69 0 0 81 69 0 0 197c-52,-8 -101,-31 -141,-66 -40,-35 -68,-81 -83,-132 -15,-51 -14,-105 1,-156 15,-51 44,-96 84,-131 40,-35 89,-57 142,-65 52,-8 106,0 154,22 48,22 89,57 118,101 29,44 45,96 45,149 0,66 -23,131 -66,181 -43,51 -103,84 -168,95l0 -194 64 0 13 -81 -77 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c2b95d59de14bbb36b0795bdf76de04a.svg";
export { ForwardRef as ReactComponent };